// extracted by mini-css-extract-plugin
export default {"drink_recipe":"DrinkRecipe_drink_recipe__sNCIz","title":"DrinkRecipe_title__ESTHH"};